module.exports = __webpack_public_path__ + "img/inverse-osmosis.551e5e22.jpg";